import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA,
  WEB_COMPONENT_EXECUTIVE_SUMMARY_ENDPOINT_MODULES_STATUS,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  EndpointModulesStatusPayload, GetEndpointModuleStatusResponse,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { EndpointModulesWebComponent } from '../../../../endpointModulesStatus';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';
import { DisplayMode } from '../../../../types/common/types';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_ENDPOINT_MODULES_STATUS)
export class GzEndpointModulesStatusWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: EndpointModulesStatusPayload;

  @query('#gzEndpointModulesStatus')
  private endpointModulesStatus: EndpointModulesWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getEndpointModuleStatus: function (request: GetWidgetDataRequest): Observable<GetEndpointModuleStatusResponse> {
              return of(this.getPayload().endpointModuleStatus);
            }.bind(this)
          }
        }
      }
    };

    if (this.endpointModulesStatus) {
      if (!this.endpointModulesStatus.started) {
        this.endpointModulesStatus.injectDependencies(dependencies);
        this.endpointModulesStatus.start();
      } else {
        this.endpointModulesStatus.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    const displayMode: DisplayMode = getDisplayMode();
    switch (displayMode) {
      case DisplayMode.PDF:
        return html`
          <gz-endpoint-modules-status-details id="gzEndpointModulesStatus"
                                              data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                                              data-targets=${JSON.stringify(this.payload?.targets)}
                                              data-can-drill-down=${true}
                                              data-display-mode=${displayMode}
          ></gz-endpoint-modules-status-details>`;
      default:
        return html`
          <gz-endpoint-modules-status id="gzEndpointModulesStatus"
                                      data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                                      data-targets=${JSON.stringify(this.payload?.targets)}
                                      data-can-drill-down=${true}
                                      data-display-mode=${displayMode}
          ></gz-endpoint-modules-status>`;
    }
  }
}
